import './videoTelematics.css';
import DriversSummary from "../../components/driverComponent/driversSummary/driversSummary";
import {useState} from "react";
import {driversSummary} from "../../data/driversData";
import VideoTelematicsFilter
    from "../../components/videoTelematicsComponent/videoTelematicsFilter/videoTelematicsFilter";
import TelematicsVideoList from "../../components/videoTelematicsComponent/telematicsVideoList/telematicsVideoList";
import Pagination from "../../shared/pagination/pagination";
import CalendarType from "../../shared/calendarType/calendarType";
import DateRangePicker from "../../shared/dateRangePicker/dateRangePicker";
import TelematicsVideoPlayer
    from "../../components/videoTelematicsComponent/telematicsVideoPlayer/telematicsVideoPlayer";
const VideoTelematics = () => {
    const [summary] = useState(driversSummary);
    const [showVideoPlayer, setShowVideoPlayer] = useState(false);
    const [videoIndex, setVideoIndex] = useState(0);

    const handleShowVideoPlayer = (val, index) => {
        setShowVideoPlayer(val);
        setVideoIndex(+index);
    }

    return(
        <>
            <div className={'video-telematics-sec page-fade-in'}>
                <div className={'content-section'}>
                    <div className=" round-corner-8 padding-tb-20 flex hr-right border-bottom margin-b-30">
                        <DateRangePicker selectRange={true} classes={'date width-300 item-height-40'}/>
                        <CalendarType/>
                    </div>
                </div>
                <div className=" margin-b-50">
                    <div className={'content-section'}>
                        {/*..... drivers overall summary .....*/}
                        <div className=""><DriversSummary summary={summary}/></div>
                    </div>
                </div>
                <div className="">
                    <div className={'content-section flex gap-0 align-top hr-space-between'}>
                        <div className="page-filter-sec">
                            <VideoTelematicsFilter/>
                        </div>
                        <div className="telematics-videos-box">
                            <div className="margin-b-50">
                                <TelematicsVideoList handleShowVideoPlayer={handleShowVideoPlayer}/>
                            </div>
                            <div className=""><Pagination/></div>
                        </div>
                    </div>
                </div>
            </div>

            {/*..... telematics video player ......*/}
            {showVideoPlayer && <TelematicsVideoPlayer index={videoIndex} handleShowVideoPlayer={handleShowVideoPlayer} />}

        </>
    )
}
export default VideoTelematics;
